import * as Yup from "yup";
import { emailAdressValidator } from "../../../Utils/stringUtls";
const generalErrorMessage = "Please fill out this field.";
const hasValue = (value) => {
    if (Array.isArray(value)) return value.length > 0;
    return typeof value === "string" && value.length > 0;
};

const validationSchemaRequiredProgramFeatures = Yup.object({
    pf_enable_kyc_conduct: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    pf_kyc_conduct: Yup.string().when("pf_enable_kyc_conduct", {
        is: (enable_kyc) => enable_kyc === "yes",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_company: Yup.string().when("pf_kyc_conduct", {
        is: (kyc_conduts) => kyc_conduts === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_contact_name: Yup.string().when("pf_kyc_conduct", {
        is: (kyc_conduts) => kyc_conduts === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_title: Yup.string().when("pf_kyc_conduct", {
        is: (kyc_conduts) => kyc_conduts === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_phone: Yup.string().when("pf_kyc_conduct", {
        is: (kyc_conduts) => kyc_conduts === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_email: Yup.string().when("pf_kyc_conduct", {
        is: (kyc_conduts) => kyc_conduts === "other",
        then: () =>
            Yup.string()
                .required(generalErrorMessage)
                .test("", "", function (item) {
                    // this.parent gives the whole parent
                    return emailAdressValidator(item);
                }),
        otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_address: Yup.string().when("pf_kyc_conduct", {
        is: (kyc_conduts) => kyc_conduts === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    pf_funding_source_consumer_option: Yup.array().optional(),

    pf_funding_source_corporate_option: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),

    pf_funding_source_corporate_other_company: Yup.string().when(
        "pf_funding_source_corporate_option",
        {
            is: (pf_funding_source_corporate_option) =>
                pf_funding_source_corporate_option === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_funding_source_corporate_other_contact_name: Yup.string().when(
        "pf_funding_source_corporate_option",
        {
            is: (pf_funding_source_corporate_option) =>
                pf_funding_source_corporate_option === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_funding_source_corporate_other_title: Yup.string().when(
        "pf_funding_source_corporate_option",
        {
            is: (pf_funding_source_corporate_option) =>
                pf_funding_source_corporate_option === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_funding_source_corporate_other_phone: Yup.string().when(
        "pf_funding_source_corporate_option",
        {
            is: (pf_funding_source_corporate_option) =>
                pf_funding_source_corporate_option === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_funding_source_corporate_other_email: Yup.string().when(
        "pf_funding_source_corporate_option",
        {
            is: (pf_funding_source_corporate_option) =>
                pf_funding_source_corporate_option === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .test("", "", function (item) {
                        // this.parent gives the whole parent
                        return emailAdressValidator(item);
                    }),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_funding_source_corporate_other_address: Yup.string().when(
        "pf_funding_source_corporate_option",
        {
            is: (pf_funding_source_corporate_option) =>
                pf_funding_source_corporate_option === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),

    pf_card_placement: Yup.array()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),

    pf_card_placement_channel: Yup.array().when(
        "pf_card_placement",
        {
            is: (val) => Array.isArray(val) && val.length > 0 && !val.includes("n/a"),
            then: (schema) =>
                schema.required(generalErrorMessage).min(1, generalErrorMessage),
            otherwise: (schema) => schema.optional(),
        }
    ),
    pf_card_placement_channel_other: Yup.string().when(
        "pf_card_placement_channel",
        {
            is: (val) => Array.isArray(val) && val.includes("other"),
            then: (schema) =>
                schema.required("Please specify the other channel").min(1, "Please specify the other channel"),
            otherwise: (schema) => schema.optional(),
        }
    ),
    pf_supplimentary_cards_permitted: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    pf_supplimentary_cards_age_limit: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    supplimentary_cards_own_profile: Yup.string().when(
        "pf_supplimentary_cards_permitted",
        {
            is: (sup_card_permitted) => sup_card_permitted === "yes",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    supplimentary_cards_share_primary_balance: Yup.string().when(
        "pf_supplimentary_cards_permitted",
        {
            is: (sup_card_permitted) => sup_card_permitted === "yes",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_card_activation_required: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    pf_card_activation_method: Yup.string().when(
        "pf_card_activation_required",
        {
            is: (pf_card_activation_required) =>
                pf_card_activation_required === "no",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_card_activation_channels: Yup.array().when(
        "pf_card_activation_required",
        {
            is: (pf_card_activation_required) =>
                pf_card_activation_required === "yes",
            then: () =>
                Yup.array().required(generalErrorMessage).min(1, generalErrorMessage),
            otherwise: () => Yup.array().optional(),
        },
    ),
    pf_card_activation_channels_other: Yup.string().when(
        "pf_card_activation_channels",
        {
            is: (pf_card_activation_channels) =>
                pf_card_activation_channels?.includes("other"),
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_card_offline_pin_required: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    pf_cardholder_notifications: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    // pf_cardholder_notifications_channels: Yup.string()
    //   .required(generalErrorMessage)
    //   .min(1, generalErrorMessage),

    pf_cardholder_notifications_channels: Yup.mixed().when(
        "pf_cardholder_notifications",
        {
            is: (val) => val && val.toLowerCase() !== "n/a",
            then: (schema) =>
                schema.test("has-value", generalErrorMessage, hasValue),
            otherwise: (schema) => schema.optional(),
        }
    ),
    pf_customer_support_channels: Yup.array().optional(),

    pf_customer_support_provider: Yup.string().optional(),
    pf_customer_support_provider_other_company: Yup.string().when(
        "pf_customer_support_provider",
        {
            is: (support_provider) => support_provider === "client-third-party",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_customer_support_provider_other_contact_name: Yup.string().when(
        "pf_customer_support_provider",
        {
            is: (support_provider) => support_provider === "client-third-party",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_customer_support_provider_other_title: Yup.string().when(
        "pf_customer_support_provider",
        {
            is: (support_provider) => support_provider === "client-third-party",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_customer_support_provider_other_phone: Yup.string().when(
        "pf_customer_support_provider",
        {
            is: (support_provider) => support_provider === "client-third-party",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
    pf_customer_support_provider_other_email: Yup.string().when(
        "pf_customer_support_provider",
        {
            is: (support_provider) => support_provider === "client-third-party",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .test("", "", function (item) {
                        // this.parent gives the whole parent
                        return emailAdressValidator(item);
                    }),
            otherwise: () => Yup.string().optional(),
        },
    ),
});
export const validationSchema = Yup.object({
    pf_enable_kyc_conduct: Yup.string().optional(),

    pf_kyc_conduct: Yup.string().optional(),

    pf_kyc_conduct_other_company: Yup.string().optional(),
    pf_kyc_conduct_other_contact_name: Yup.string().optional(),
    pf_kyc_conduct_other_title: Yup.string().optional(),
    pf_kyc_conduct_other_phone: Yup.string().optional(),

    pf_kyc_conduct_other_email: Yup.string()
        .optional()
        .test("", "", function (item) {
            if (!item) return true;
            return emailAdressValidator(item);
        }),

    pf_kyc_conduct_other_address: Yup.string().optional(),

    pf_funding_source_consumer_option: Yup.array().optional(),
    pf_funding_source_corporate_option: Yup.string().optional(),

    pf_funding_source_corporate_other_company: Yup.string().optional(),
    pf_funding_source_corporate_other_contact_name: Yup.string().optional(),
    pf_funding_source_corporate_other_title: Yup.string().optional(),
    pf_funding_source_corporate_other_phone: Yup.string().optional(),

    pf_funding_source_corporate_other_email: Yup.string()
        .optional()
        .test("", "", function (item) {
            if (!item) return true;
            return emailAdressValidator(item);
        }),

    pf_funding_source_corporate_other_address: Yup.string().optional(),

    pf_card_placement: Yup.array().optional(),

    pf_card_placement_channel: Yup.array().optional(),

    pf_card_placement_channel_other: Yup.string().optional(),

    pf_supplimentary_cards_permitted: Yup.string().optional(),
    pf_supplimentary_cards_age_limit: Yup.string().optional(),

    supplimentary_cards_own_profile: Yup.string().optional(),
    supplimentary_cards_share_primary_balance: Yup.string().optional(),

    pf_card_activation_required: Yup.string().optional(),
    pf_card_activation_method: Yup.string().optional(),
    pf_card_activation_channels: Yup.array().optional(), 
    pf_card_activation_channels_other: Yup.string().optional(), 
    pf_card_offline_pin_required: Yup.string().optional(), 
    pf_cardholder_notifications: Yup.string().optional(),
    pf_cardholder_notifications_channels: Yup.mixed().optional(), 
    pf_customer_support_channels: Yup.array().optional(), 
    pf_customer_support_provider: Yup.string().optional(), 
    pf_customer_support_provider_other_company: Yup.string().optional(),
    pf_customer_support_provider_other_contact_name: Yup.string().optional(),
    pf_customer_support_provider_other_title: Yup.string().optional(),
    pf_customer_support_provider_other_phone: Yup.string().optional(),
    pf_card_activation_parameters: Yup.array().optional(),
    pf_card_reloading_options: Yup.array().optional(),
    pf_card_reloading_options_other: Yup.string().optional(), 
    pf_card_closure_how_will_card_be_closed: Yup.string().optional(),
    pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure: Yup.string().optional(),
    pf_customer_support_provider_other_email: Yup.string()
        .optional()
        .test("", "", function (item) {
            if (!item) return true;
            return emailAdressValidator(item);
        }),
});
 
